export const tabsPreset = {
  tabs: {
    tablist: {
      background: 'var(--neutral--10)',
    },
    tabpanel: {
      padding: '0',
    },
    tab: {
      padding: '8px 16px',
      color: 'var(--neutral--60)',
      activeColor: 'var(--neutral--80)',
      activeBackground: '#fff',
      hoverBackground: 'var(--neutral--10)',
      fontWeight: '700',
      focusRing: {
        width: '1px',
        color: 'rgba(21, 93, 252, 0.12)',
        offset: '0rem',
        style: 'solid',
      },
    },
    css: () => `
      .p-tablist {
        border-radius: 3rem;
        padding: 4px;
        display: flex;
      }
      .p-tablist-tab-list {
        border: none;
      }
      .p-tab {
        border-radius: 3rem;
        border: none;
        flex: 1 1 auto;
        text-align: center;
      }
      .p-tab .pi-exclamation-circle {
        color: #C7770B;
        font-size: 0.9rem;
      }
      .p-tab .pi-check {
        color: #007223;
        font-size: 0.9rem;
      }
    `,
  },
};
